import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { TableContextConsumer } from '../context';
import { Checkbox } from '../../checkbox/checkbox';
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkBoxRef = null;
        _this.setCheckbox = function (elem) {
            _this.checkBoxRef = elem;
        };
        _this.onClick = function (event) {
            var props = _this.props;
            var isWithSelect = props.isSelected !== undefined && props.onSelect;
            if (isWithSelect && event.target && _this.checkBoxRef && _this.checkBoxRef.contains(event.target)) {
                return;
            }
            if (_this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        _this.renderTableRow = function (context) {
            var props = _this.props;
            var isClickable = !!props.onClick;
            var isWithSelect = props.isSelected !== undefined && props.onSelect;
            var classNames = namespacedClassnames('table-row', props.className, isClickable ? 'clickable' : '', isWithSelect ? 'with-select' : '', props.isSelected ? 'selected' : '');
            var gridStyle = {
                gridTemplateColumns: _this.props.fullWidthRow ? '100%' : context.colWidths.join(' ')
            };
            var checkbox = isWithSelect && props.onSelect ? (React.createElement("div", { className: 'checkbox-row', ref: _this.setCheckbox },
                React.createElement(Checkbox, { large: true, value: props.isSelected || false, onChange: _this.onSelect, disabled: _this.props.disableSelect }))) : null;
            return (React.createElement("div", { className: classNames, onClick: _this.onClick, style: gridStyle },
                checkbox,
                props.children));
        };
        _this.onSelect = function (newVal) {
            if (_this.props.onSelect) {
                _this.props.onSelect(newVal);
            }
        };
        return _this;
    }
    TableRow.prototype.render = function () {
        return (React.createElement(TableContextConsumer, { render: this.renderTableRow }));
    };
    return TableRow;
}(React.Component));
export { TableRow };
//# sourceMappingURL=table-row.js.map